export function normalizePhone(value) {
  if (!value) return "";
  const trimmed = String(value).trim();
  const hasPlus = trimmed.startsWith("+");
  const digits = trimmed.replace(/\D/g, "");
  return hasPlus ? `+${digits}` : digits;
}

export function isValidE164Phone(value) {
  if (!value) return false;
  const normalized = normalizePhone(value);
  return /^\+[1-9]\d{7,14}$/.test(normalized);
}
